var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"HashtagsAboutYou"},[_c('h4',[_vm._v("Hashtag")]),_c('hr'),_c('div',{staticClass:"row"},_vm._l((_vm.list),function(v,i){return _c('span',{key:i,staticClass:"mb-0 mr-1 yellow-text-bg"},[_vm._v(_vm._s(v.tag_name))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }